export default Object.freeze([
    { key: 'EQUALS', label: '=' },
    { key: 'GREATER_THAN', label: '>' },
    { key: 'GREATER_THAN_OR_EQUAL_TO', label: '≥' },
    { key: 'LESS_THAN', label: '<' },
    { key: 'LESS_THAN_OR_EQUAL_TO', label: '≤' },
    { key: 'NOT_EQUALS', label: '≠' },
    { key: 'INCLUDES_ALL', label: 'includes all' },
    { key: 'INCLUDES_NONE', label: 'includes none' },
]);
